import { render, staticRenderFns } from "./NegativeBalancePopup.vue?vue&type=template&id=b107f2e0&scoped=true"
import script from "./NegativeBalancePopup.vue?vue&type=script&lang=js"
export * from "./NegativeBalancePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b107f2e0",
  null
  
)

export default component.exports